import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { isAdminLoggedIn, setAdminSession } from "../coreFIles/auth";
import { adminLoginAction } from "../Action/action";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(true);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const from = location.state?.from?.pathname || "/dashboard";

  useEffect(() => {
    if (isAdminLoggedIn()) {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!username.trim()) {
      setError("Username is required.");
      return;
    }
    if (!password) {
      setError("Password is required.");
      return;
    }

    setLoading(true);
    try {
      const res = await adminLoginAction({ username: username.trim(), password });

      if (res?.success) {
        const sessionData = res?.data || {};
        const authToken =
          sessionData?.authToken ||
          sessionData?.token ||
          sessionData?.access_token ||
          sessionData?.accessToken ||
          res?.authToken ||
          res?.token ||
          "";

        setAdminSession({ ...sessionData, authToken });
        // eslint-disable-next-line no-unused-vars
        const _ = remember; // placeholder: later can control cookie expiry
        navigate(from, { replace: true });
      } else {
        setError(res?.message || res?.msg || "Login failed. Please check credentials.");
      }
    } catch (err) {
      // Axios error shape: err.response?.data?.msg
      const msg =
        err?.response?.data?.msg ||
        err?.response?.data?.message ||
        err?.message ||
        "Login failed. Please try again.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-brand">
          <div className="auth-brand-row">
            <img src="/images/klc-logo.png" alt="KLC Admin" style={{ width: "200px", height: "auto" }} />
          </div>
        </div>

        <form onSubmit={onSubmit}>
          <div className="form-group">
            <label>Username</label>
            <input
              className="form-control"
              type="text"
              placeholder="Enter username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              className="form-control"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>

          <div className="auth-row">
            <label className="auth-remember">
              <input
                type="checkbox"
                checked={remember}
                onChange={(e) => setRemember(e.target.checked)}
              />
              Remember me
            </label>
            <Link className="action-link" to="/forgot-password">
              Forgot password?
            </Link>
          </div>

          <button className="btn btn-primary auth-submit" type="submit">
            {loading ? "Signing In..." : "Sign In"}
          </button>
        </form>

        {error ? <div className="auth-error">{error}</div> : null}
      </div>
    </div>
  );
}

